import React from 'react';
import DocumentMeta from 'react-document-meta';
import { withStyles } from '@material-ui/core/styles';
import Snow from 'react-snow-effect';
import moment from 'moment';

import Counter from './Counter.jsx';

import { bgImage } from '../img/bgImageConstants.js';

const styles = {
    root: {
        flexGrow: 1,
        width: '100vw',
        height: '100vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
    },
};

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scale: Math.min(window.screen.width / 360, 1),
            differenceX: 1918 - window.screen.width,
            differenceY: 1052 - window.screen.height,
            nextXmasYear: moment().year(),
        };
    }

    componentWillMount() {
        this.resizeView();
        window.addEventListener('resize', this.resizeView);
    }

    resizeView = () => {
        this.setState({
            scale: Math.min(window.screen.width / 360, 1),
            differenceX: 1918 - window.screen.width,
            differenceY: 1052 - window.screen.height,
        });
    };

    render() {
        const {classes} = this.props;
        const {nextXmasYear} = this.state;
        const keywords = [
            'Christmas counter',
            'Christmas countdown',
            'how long until Christmas',
            `Christmas ${nextXmasYear}`,
            'meres gia ta xristougenna',
            'μέρες για τα χριστούγεννα',
            'christmas gifts',
            'christmas gift ideas',
            'christmas gifts for her',
            'homemade christmas gifts',
            'christmas gifts for him',
            'unusual christmas gifts',
            'cheap christmas gifts',
            'christmas gifts for mum',
            'mens christmas gifts',
            'christmas gift boxes',
            'christmas gifts for men',
            'christmas gift bags',
            'christmas gift',
            'handmade christmas gifts',
            'personalised christmas gifts',
            'christmas gift ideas for her',
            'unique christmas gifts',
            'cool christmas gifts',
            'christmas gifts for dad',
            'christmas gifts for boyfriend'
        ];

        const meta = {
            title: `Christmas ${nextXmasYear} is coming - Merry Christmas`,
            description: 'How many days until Christmas ?  Find out how many days until Christmas in xmascounter.',
            meta: {
                charset: 'utf-8',
                name: {
                    keywords: keywords.join()
                }
            }
        };
        return (
            <div
                className={classes.root}
                style={{
                    backgroundImage: `${bgImage}`,
                    WebkitTransform: `scale(${this.state.scale})`,
                    MsTransform: `scale(${this.state.scale})`,
                    transform: `scale(${this.state.scale})`,
                }}
            >
                <DocumentMeta {...meta} />
                <Snow />
                <Counter
                    style={{
                        position: 'absolute',
                        top: '40%',
                    }}
                    endDate={`24-12-${nextXmasYear} 24:00:00`}
                />
                <div>
                    <ins className="adsbygoogle"
                         style={{display: 'block'}}
                         data-ad-client="ca-pub-3226639581814599"
                         data-ad-slot="9560521710"
                         data-ad-format="auto"
                         data-full-width-responsive="true" />
                    <script>
                        (adsbygoogle = window.adsbygoogle || []).push({});
                    </script>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(App);


// WEBPACK FOOTER //
// ./src/components/App.jsx